var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "org-chart-container" } }, [
    _c(
      "div",
      { staticClass: "menu-container" },
      [
        _c(
          "v-layout",
          { attrs: { row: "" } },
          [
            _c(
              "v-btn",
              {
                on: {
                  click: function ($event) {
                    return _vm.bigger()
                  },
                },
              },
              [_vm._v("+")]
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                on: {
                  click: function ($event) {
                    return _vm.smaller()
                  },
                },
              },
              [_vm._v("-")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "v-card",
          [
            _c(
              "v-card-title",
              [
                _c(
                  "div",
                  {
                    staticClass: "action-title",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [_c("span", [_vm._v("Support actions")])]
                ),
                _vm._v(" "),
                _vm._l(_vm.supportActions, function (action) {
                  return _c(
                    "div",
                    { key: action, staticClass: "action-item" },
                    [
                      _vm._v(
                        "\n          " + _vm._s("* " + action) + "\n        "
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }